var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClockSolid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 53 52",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 26C0.5 11.6391 12.1391 0 26.5 0C35.3279 0 43.1273 4.39812 47.8268 11.123C50.7723 15.338 52.5 20.467 52.5 26C52.5 40.3609 40.8609 52 26.5 52C12.1391 52 0.5 40.3609 0.5 26ZM26.5007 39.5829C34.002 39.5829 40.0829 33.502 40.0829 26.0007C40.0829 18.4995 34.002 12.4185 26.5007 12.4185C18.9995 12.4185 12.9185 18.4995 12.9185 26.0007C12.9185 33.502 18.9995 39.5829 26.5007 39.5829ZM26.5007 42.2507C35.4753 42.2507 42.7507 34.9753 42.7507 26.0007C42.7507 17.0261 35.4753 9.75071 26.5007 9.75071C17.5261 9.75071 10.2507 17.0261 10.2507 26.0007C10.2507 34.9753 17.5261 42.2507 26.5007 42.2507ZM26.1051 15.5522C26.8418 15.5522 27.439 16.1494 27.439 16.8861V26.6498H31.6539C32.3906 26.6498 32.9878 27.247 32.9878 27.9837C32.9878 28.7203 32.3906 29.3175 31.6539 29.3175H26.1051C25.3684 29.3175 24.7712 28.7203 24.7712 27.9837V16.8861C24.7712 16.1494 25.3684 15.5522 26.1051 15.5522Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockSolid);
export default __webpack_public_path__ + "static/media/clock-solid.70bd1a25.svg";
export { ForwardRef as ReactComponent };